export default __webpack_public_path__ + "static/media/in-the-spotlight-spell-of-genesis.186603f6.png";